<template>
    <div id="main-columns" class="columns is-centered mx-2 my-5">
        <div class="column is-two-thirds">
            
            <div class="header my-5">
                <h3>Our Organization</h3>
            </div>

            <p class="body-text my-5">If you came to this website from the sundayacrossamerica.org address, welcome! This page is managed by a group of volunteers in North Carolina who strive to promote Sabbath Keeping and who hope you prayerfully consider starting a group in your area or even across your entire state of persons willing to promote Sunday as a special and holy day. Those of us in North Carolina are more than willing to hear from you and to share our experiences and Sabbath Keeping events with you.</p>

            <p class="body-text mt-5"><b>Sunday in North Carolina</b> is a subsidiary of Bethel Ensemble, focusing primarily on the honor and celebration of the Sabbath Day.<br><br>
                <b>Bethel Ensemble</b>, established 2021, is a 501(c)(3) faith-based non-profit organization whose mission is to sponsor, produce, encourage, support and provide religious, educational, and charitable activities related to the performing arts and the Biblical mandate of honoring the Sabbath.</p>

            <p class="body-text my-5">Bethel Ensemble, Inc has four legally established DBA's:</p>
            <ul class="body-text my-5 mx-5 dotted">
                <li><p><b>THE LAST SUPPER</b>, A Musical Enactment</p></li>
                <li><p><b>Sunday in North Carolina</b></p></li>
                <li><p><b>Sunday Across America</b></p></li>
                <li><p><b>My Sabbaths</b>, which focuses upon individuals who usually find themselves working on Sundays and need to choose another day for Faith, Family and Far-Reaching Benefits.</p></li>
            </ul>
            
            <div class="divider my-2"></div>

            <h3 class="text-color-primary has-text-centered mt-5"> Sabbath {{ attribution ? "Quote" : "Thought" }} for {{quotes[0].month}}</h3>
            <div class="columns is-centered">
                <div class="column is-three-quarters has-text-centered body-text">
                    <QuoteView :quoteDict="quotes[0]" :month="false" />
                    <RouterLink to="/quotes" class="button to-quotes my-4">View Past Quotes and Thoughts</RouterLink>
                </div>
            </div>

            <div class="divider my-2"></div>


            <div class="header my-5">
                <h3>Bookmarks</h3>
            </div>

            <div class="columns is-centered is-vcentered is-desktop">                    
                <div class="column is-two-fifths-desktop mx-5">
                    <div class="columns is-centered is-vcentered is-desktop mx-5">
                        <div class="column is-three-fifths-desktop is-flex is-justify-content-center">
                            <img src="../assets/bookmark-front.jpg" alt="Bookmark Front">
                        </div>
                        <div class="column is-three-fifths-desktop is-flex is-justify-content-center">
                            <img src="../assets/bookmark-back.jpg" alt="Bookmark Back">
                        </div>
                    </div>
                </div>
                <div class="column is-two-fifths-desktop mx-5 ">
                    <div class="divider my-2"></div>
                        <span class="body-text has-text-centered is-size-4-fullhd is-size-5-widescreen is-size-6-desktop">
                            <p id="bookmark-description" class="p-3">Get your own bookmark! We have versions for any US state, as well as a 'Sunday Across America' bookmark. To receive one, mail us a donation along with your address and a message stating which version you would prefer.</p>
                            <p id="bookmark-mailing-address" class="p-3">Sunday in North Carolina<br>P.O. Box 282<br>Olivia, NC 28368-0282</p>
                        </span>
                    <div class="divider my-2"></div>
                </div>
            </div>

            <div class="header my-5">
                <h3>Our Background</h3>
            </div>

            <div class="body-text">
                <p>Sunday in North Carolina is a 501(c)(3) faith-based charity officially recognized by the IRS as a public charity on November 4, 2021.
                    It is a mission of Bethel Ensemble, whose E.I.N. is 86-2994560.
                    We gave ourselves 12 to 18 months to get organized. The first organizational meeting was held on April 20, 2021 at St. Paul Lutheran Church, Salisbury, NC.
                    The next organizational meeting was conducted at St. Francis Anglican Parish in Sanford, NC, on July 27, 2021.
                    At this meeting, those felt called by the Holy Spirit to establish a new group were
                    Brenda Dasher, Fr. Matthew Garrison, James S. Gibbons, Jr., Dr. Sidney 'Joe' Morgan, M.D., Brendan Mungwena, Chaplain Andrew Krey, Thomas Mitz, Gordy Reese, Cheryl Schmidt, Imelda Tablada, and Shirley Wright.
                    At that July 2021 meeting, it was decided that "Our mission is to help Tar Heels make Sunday a very special day for themselves, their family, and their community."
                    Furthermore, it was said that "you might have heard that Sunday is for faith, family, and football. We believe Sunday is for faith, family, and far-reaching benefits." </p>
                <p class="my-4 has-text-weight-bold">A little more background on Andrew Krey</p>
                <p>Chaplain Andy Krey served on the national board of the Lord's Day Alliance of the United States (LDA) established in 1888 for 12 years.
                    The mission of the LDA is to encourage all people to recognize and observe a day of Sabbath rest and to worship the risen Lord Jesus Christ on the Lord's Day, Sunday.
                    In 1969, Chaplain Krey joined the Merchant Marine and served as a crew member in the galleys on American flag supper oil tankers.
                    Since 1973, he has served as a chaplain to the maritime community and international seafarers in the ports of Boston, Houston, Providence, New Haven, New York/New Jersey, and Savannah.
                    He has visited with the crews of all types of oceangoing ships - cruise ships, container ships, chemical carriers, fishing vessels, banana boats, submarines, etc.
                    He has met with thousands of crew members, many speaking to him about how tired they were.
                    They went ten to 15 months without one eight-hour section of time off.
                    They were overworked, sleep deprived, and underpaid to be a world away from their families, for whom they were sacrificing the 'normal' life.</p>
            </div>
            <div class="header my-5">
                <h3>Events</h3>
            </div>

            <div class="body-text">
                <h4>National Day of Prayer</h4>
                <!-- <br> -->
                <p class="my-3">For the last three years, Bethel Ensemble volunteers in Lee County, North Carolina have been asked to present a National Day of Prayer event. The National Day of Prayer is observed every year on the first Thursday of May. As you might recall, Bethel Ensemble's mission includes promoting the Biblical mandate of keeping the Sabbath. The annual National Day of Prayer gives us another day to invite the public to the "far reaching benefits" of a weekly day of rest.</p>
                <br>
                <p class="my-3">The mailing address for financial gifts, which are always welcome, is as follows:</p>
                <!-- <br> -->
                <p class="my-3">National Day of Prayer<br>1089 Wilkins Drive<br>Sanford, NC 27330</p>
                <br>
                <p class="my-3">These individuals have voluntarily committed themselves to serve as the organizing task force for an annual National Day of Prayer event in Lee County, North Carolina:</p>
                <!-- <br> -->
                <ul class="my-3">
                    <li>Max Dolan, Lee County Veterans Council</li>
                    <li>Dana Garrett, MD, Treasurer</li>
                    <li>Sr. Chief Gary Gillian, chair, Lee County Veterans Council</li>
                    <li>Chaplain Andrew Krey, Co-chair</li>
                    <li>Joseph R. Zanga MD, Co-chair</li>
                    <li>Ed Zeglarski, Chaplain VFW Post 5631</li>
                    <li>Rev. Jean Sparks, Chaplain American Legion Post 382</li>
                </ul>
                <p class="my-3">As well as our members-at large: Andrew Bass, Alex Bogaski, Roger Buswell, Captain Ronald Hewett, E J Oberkirsch, and Beth R. Puckett</p>
            </div>

            <div class="columns is-centered is-vcentered is-desktop">                    
                <div class="column is-two-fifths-desktop mx-5">
                    <div class="divider my-2"></div>
                    <h3 id="watch-playback" class="text-color-primary has-text-centered p-5">Watch a playback of the Chiz Rider Concert!</h3>
                    <div class="divider my-2"></div>
                </div>
                <div class="column is-two-fifths-desktop mx-5">
                    <div class="video-container">
                        <iframe width="100%" height="auto" src="https://youtube.com/embed/5UCxVbWzY-k" allowfullscreen></iframe>
                    </div>
                </div>
            </div>

            <!-- <div class="body-text my-5 has-text-centered">
                <p>Coming soon: Watch clips from our February 2026 Sabbath Symposium!</p>
            </div> -->

            <div class="header my-5">
                <h3>Contact Us</h3>
            </div>
            <div class="columns is-centered is-vcentered is-desktop body-text">                    
                <div class="column is-two-fifths-desktop">
                    <p class="has-text-weight-bold">Mailing Address:</p>
                    <p>P.O. Box 282<br>Olivia, NC 28368-0282</p>
                </div>
                <div class="column is-two-fifths-desktop">
                    <p class="has-text-weight-bold">Contact Executive Director (Andrew Krey):</p>
                    <p>chaplainkrey@gmail.com<br>912-441-4640 (Mobile, texts preferred)</p>
                </div>
            </div>
            <div class="columns is-centered is-vcentered is-desktop body-text">
                <div class="column is-four-fifths-desktop">
                    <a class="link" href="/sundayinnc.pdf" type="application/pdf" download="sundayinnc.pdf">Want to donate or get in touch? Click here to download a printable form!</a>
                </div>  
            </div>

            <div class="header my-5">
                <h3>Board of Directors</h3>
            </div>
            <div class="columns is-centered is-vcentered is-desktop"> 
                <div class="column is-two-fifths-desktop">
                    <ul class="body-text">
                        <li v-for="director in directors.withRoles" :key="director.name">
                            <span class="has-text-weight-bold">{{ director.name }}</span> - {{ director.role }}
                        </li>
                    </ul>
                </div>
                <div class="column is-two-fifths-desktop">
                    <ul class="body-text">
                        <li v-for="director in directors.withoutRoles" class="has-text-weight-bold" :key="director.name">
                            {{ director.name }}
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <div>  -->
                <!-- <p class="body-text">Our late secretary, Jim Gibbons, sadly departed this life to enter a perfect rest faithfully waiting for the glorious resurrection. Jim's Celebration of Life is scheduled for Saturday August 23, 2025 in Panama Beach City, Florida. Chaplain & Sally Krey will be attending. In addition to the congregation where Jim and Sharon attended, the family has followed Jim's wish that memorial gifts be sent to Bethel Ensemble. Jim came up with the name of this 501(c)(3) Charity. Jim took Board Meeting minutes for the last time on October 16, 2024 at the meeting in Garden City, GA. Jim, we will miss you. God knows we will miss you!</p> -->
            <!-- </div> -->
            <div class="text-color-primary mt-5 is-size-4">
                <h5><b>An Update On Bethel Ensemble's Current Leadership and Divisions</b></h5>
            </div>
            <div class="body-text">
                <p class="my-5">James Gibbons passed away this summer and is sorely missed. Our March 21 & 22, 2026 productions of THE LAST SUPPER at The Pal Theater in Millen, Georgia were the first time since 2009 that Jim will not be serving as our "official greeter" in the theater's lobby. So, we have an opening on the Board of Directors. Jim served as the Secretary of the Board but we will share that responsibility among other leaders unless someone volunteers and is elected to that office. Our Treasurer, Cheryl A. Schmidt, and I as volunteer Executive Director can sign legal documents.
                </p>

                <p class="my-5">Other People in Leadership Include:</p>
                <ul class="my-5 mx-5 dotted">
                    <li><b>Dr. Dana Garrett, M.D.</b> and <b>Dr. Joseph Zanga, M.D.</b>, who are check signers for the Sabbath Keeping account.</li>
                    <li><b>Major Joseph Crews</b>, who signs checks for THE LAST SUPPER account.</li>
                    <li><b>Robert Cottle</b> and <b>John Parcels</b>, who serve as the 2026 co-directors of THE LAST SUPPER.</li>
                    <li><b>Mandy Underwood</b>, the Executive Director of the Jenkins County Development Authority and Chamber of Commerce, who joins Bethel Ensemble as co-producer.</li>
                    <li><b>Michael Steinagel</b>, who has volunteered to organize group ticket sales.</li>
                </ul> 

            </div>
        </div>
    </div>
</template>

<script setup>

import quotes from "../../public/quotes.json"
import directors from "../../public/directors.json"
import QuoteView from "./QuoteView.vue"

let attribution = quotes[0].attribution

</script>


<style lang="scss">
@import '../../public/constants.scss';

.header {
    color: $secondary;
    background-color: $primary;
    padding: .75rem;
}

.divider {
    background-color: $primary;
    height: 10px;
}

#watch-playback {
    font-size: max(1.5rem, 2vw);
}

.video-container { position: relative; padding-bottom: 56.25%; padding-top: 30px; height: 0; overflow: hidden; }

.video-container iframe, .video-container object, .video-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }

.link {
    color: $primary;
    text-decoration: underline;
}
.link:hover {
    color: $primaryHover;
}

.to-quotes {
    background-color: $primary;
    color: $secondary;
    font-weight: 600;
    font-size: 1.2rem;
    border: none;
}

.to-quotes:hover {
    background-color: $primaryHover;
    color: $secondary;
}

</style>
